var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGeneralToolLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.462 197.405"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.75 0L0 75.75v121.655h7V78.649L75.75 9.9l68.712 68.712v111.793h-13.42l-31.118-31.118a30.044 30.044 0 10-4.769 5.131l32.987 32.987h23.32V75.712zM59.506 157.861a22.942 22.942 0 1116.224 6.722 22.791 22.791 0 01-16.224-6.723z",
    "data-name": "Layer 1"
  }))));
}

export default SvgGeneralToolLogo;